import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

export const Container = styled.div`
  width: clamp(350px, 420px, 90vw);
  box-shadow: 0 2.5rem 4rem -3rem rgba(247, 25, 99, 0.1);
  padding-top: 3rem;
  padding-bottom: 3rem;

  h3 {
    font-size: 1.3135rem;
  }

  p {
    margin-bottom: 1.5rem;
  }
`

export const ContainerReviewCart = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: ${theme.colors.neutralLow};
    color: ${theme.colors.white};

    width: 100%;
    padding: 0.375rem 2rem 0.375rem 1rem;

    a {
      text-decoration: underline;
      color: ${theme.colors.white};
      font-weight: bold;
    }

    @media ${device.tablet_max} {
      flex-direction: column;
      padding-right: 1rem;
    }
  `}
`
